import * as React from "react";
const SvgFiBrandsMcdonalds = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      fill="#151A2D"
      fillRule="evenodd"
      clipPath="url(#fi-brands-mcdonalds_svg__a)"
      clipRule="evenodd"
    >
      <path d="M15.771 2.4c-1.939 0-3.668 2.584-4.8 6.623C9.84 4.983 8.11 2.4 6.172 2.4 2.764 2.4 0 10.996 0 21.6h2.743c0-9.846 1.535-17.828 3.428-17.828S9.6 11.14 9.6 20.228h2.743c0-9.088 1.535-16.456 3.428-16.456S19.2 11.754 19.2 21.599h2.742c.001-10.603-2.762-19.2-6.171-19.2M23.323 20.228h-.006a.68.68 0 0 0-.688.683.684.684 0 0 0 .679.689h.009a.68.68 0 0 0 .684-.689.68.68 0 0 0-.678-.683m-.007 1.271c-.32 0-.563-.253-.563-.589 0-.328.244-.581.563-.581.315 0 .559.253.559.582 0 .335-.244.588-.56.588" />
      <path d="M23.304 20.869h-.13v-.255h.164c.084 0 .175.016.175.122 0 .127-.1.133-.209.133m.333-.127c0-.153-.089-.23-.278-.23h-.309v.802h.124v-.344h.132l.216.345h.134l-.227-.354c.117-.014.208-.074.208-.22" />
    </g>
    <defs>
      <clipPath id="fi-brands-mcdonalds_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsMcdonalds;
